import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="86" height="65" viewBox="0 0 86 65" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.8959 47.3845C9.58259 47.0049 3.76953 40.9548 3.76953 33.5469C3.76953 25.8942 9.9733 19.6904 17.626 19.6904C17.9828 19.6904 18.3363 19.7039 18.6862 19.7304C20.5757 8.53094 30.32 0 42.0569 0C52.2506 0 60.9413 6.4351 64.2882 15.4645C65.0075 15.3659 65.7419 15.3149 66.4882 15.3149C75.3493 15.3149 82.5326 22.4983 82.5326 31.3593C82.5326 40.2204 75.3493 47.4037 66.4882 47.4037C66.4696 47.4037 66.451 47.4037 66.4323 47.4036H42.1656C42.1294 47.4038 42.0931 47.4038 42.0569 47.4038C42.0206 47.4038 41.9844 47.4038 41.9482 47.4036H16.8959V47.3845Z"
      fill="#C7BCE4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.8959 47.3845C9.58259 47.0049 3.76953 40.9548 3.76953 33.5469C3.76953 25.8942 9.9733 19.6904 17.626 19.6904C17.9828 19.6904 18.3363 19.7039 18.6862 19.7304C20.5757 8.53094 30.32 0 42.0569 0C52.2506 0 60.9413 6.4351 64.2882 15.4645C65.0075 15.3659 65.7419 15.3149 66.4882 15.3149C75.3493 15.3149 82.5326 22.4983 82.5326 31.3593C82.5326 40.2204 75.3493 47.4037 66.4882 47.4037C66.4696 47.4037 66.451 47.4037 66.4323 47.4036H42.1656C42.1294 47.4038 42.0931 47.4038 42.0569 47.4038C42.0206 47.4038 41.9844 47.4038 41.9482 47.4036H16.8959V47.3845Z"
      fill="url(#paint0_linear_19229_46789)"
    />
    <ellipse
      cx="43"
      cy="58.4384"
      rx="42.5"
      ry="6.12981"
      fill="url(#paint1_radial_19229_46789)"
      fillOpacity="0.8"
    />
    <path
      d="M42.2923 15.4309C42.6836 15.0355 43.3224 15.0355 43.7137 15.4309L49.8107 21.591C50.4357 22.2225 49.9884 23.2945 49.1 23.2945H36.906C36.0176 23.2945 35.5703 22.2225 36.1953 21.591L42.2923 15.4309Z"
      fill="white"
    />
    <rect x="39.7344" y="21.2512" width="6.53846" height="7.35577" rx="1" fill="white" />
    <rect x="39.7344" y="30.2415" width="6.53846" height="3.26923" rx="1" fill="white" />
    <rect x="39.7344" y="35.1453" width="6.53846" height="1.63462" rx="0.817308" fill="white" />
    <defs>
      <linearGradient
        id="paint0_linear_19229_46789"
        x1="60.6541"
        y1="5.83432"
        x2="30.3886"
        y2="44.8513"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#7977C1" />
        <stop offset="1" stopColor="#C7BCE4" stopOpacity="0" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_19229_46789"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(43 58.4384) rotate(90) scale(6.12981 42.5)">
        <stop stopColor="#C7BCE4" />
        <stop offset="1" stopColor="#C7BCE4" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

const UploadCloudIcon = (props) => <Icon component={svg} {...props} />;

export default UploadCloudIcon;
